import { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Plus, Package } from "lucide-react";
import AssignItemModal from "./InventoryModals/AssignItemModal";

export default function AssignItems() {



  const [isModalOpen, setIsModalOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);


  const [editItem, setEditItem] = useState(null);

  const [deleteItem, setDeleteItem] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [responseModal, setResponseModal] = useState({
    show: false,
    success: false,
    message: "",
  });


  const API_URL = "https://demouptask.visiontrek.io/api/inventory/with-assignments";

  // const API_URL = "https://uptask.visiontrek.io/api/inventory/with-assignments";

  // ✅ Fetch Inventory
  const fetchItems = async () => {
    setLoading(true);
    try {
      const token = Cookies.get("token");

      const res = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data?.success) {
        // ✅ show only assigned items
        const assigned = res.data.data.filter(
          (i) => i.assignment_status !== null && i.assignment_status !== "Unassigned"
        );
        setItems(assigned);
      }
    } catch (err) {
      console.log("Error fetching inventory:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);


  // const handleDelete = async () => {
  //   if (!deleteItem) return;

  //   setDeleteLoading(true);

  //   try {
  //     const token = Cookies.get("token");

  //     const res = await axios.delete(
  //       `https://uptask.visiontrek.io/api/inventory/unassign`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //         data: {
  //           inventory_id: deleteItem.inventory_id || deleteItem.id, // 👈 important
  //         },
  //       }
  //     );

  //     if (res.data?.success) {
  //       setResponseModal({
  //         show: true,
  //         success: true,
  //         message: "Item unassigned successfully",
  //       });

  //       fetchItems();
  //     } else {
  //       throw new Error();
  //     }
  //   } catch (err) {
  //     console.log("DELETE ERROR:", err);
  //     setResponseModal({
  //       show: true,
  //       success: false,
  //       message: "Delete failed",
  //     });
  //   } finally {
  //     setDeleteLoading(false);
  //     setDeleteItem(null);
  //   }
  // };

  const handleDelete = async () => {
    if (!deleteItem) return;

    setDeleteLoading(true);

    try {
      const token = Cookies.get("token");

      const res = await axios.delete(
        `https://demouptask.visiontrek.io/api/inventory/unassign/${deleteItem.inventory_id}`, // ✅ ID in URL

        // `https://uptask.visiontrek.io/api/inventory/unassign/${deleteItem.inventory_id}`, // ✅ ID in URL
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data?.success) {
        // ✅ Also update inventory status back to 'Assignable'
        try {
          await axios.put(
            `https://demouptask.visiontrek.io/api/inventory/${deleteItem.inventory_id}`,

            // `https://uptask.visiontrek.io/api/inventory/${deleteItem.inventory_id}`,
            { status: "Assignable" },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
        } catch (updateErr) {
          console.log("Status update failed, but unassign worked:", updateErr);
        }

        // instant UI update
        setItems(prev => prev.filter(i => i.id !== deleteItem.id));

        setDeleteItem(null);

        setResponseModal({
          show: true,
          success: true,
          message: "Item unassigned successfully",
        });
      } else {
        throw new Error();
      }
    } catch (err) {
      console.log("DELETE ERROR:", err);

      setDeleteItem(null);

      setResponseModal({
        show: true,
        success: false,
        message: "Delete failed",
      });
    } finally {
      setDeleteLoading(false);
    }
  };


  return (
    <>
      <div className="rounded-2xl md:mt-20 p-6 bg-gradient-to-br from-[#1e174a] to-[#0f0c29] text-white border border-white/10 shadow-[0_30px_100px_rgba(0,0,0,0.7)]">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-semibold">
            Assigned Inventory
          </h1>

          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-2 whitespace-nowrap bg-purple-600 hover:bg-purple-500 px-4 py-2 rounded-lg text-sm"
          >
            <Plus size={16} />
            Assign Item
          </button>
        </div>

        {/* TABLE / EMPTY */}
        <div className="min-h-[320px] rounded-xl bg-white/5 border border-white/10 backdrop-blur-xl overflow-hidden">

          {loading ? (
            <div className="flex justify-center items-center h-[300px]">
              <div className="w-8 h-8 border-2 border-purple-500 border-t-transparent rounded-full animate-spin" />
            </div>
          ) : items.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-[300px]">
              <Package size={40} className="text-white/30 mb-3" />
              <p className="text-white/60 text-sm">
                No assigned items
              </p>
            </div>
          ) : (
            <div className="max-h-[420px] overflow-y-auto">
              <table className="w-full text-sm">

                {/* HEADER */}
                <thead className="sticky top-0 bg-[#12082f]/90 backdrop-blur-xl text-white/50 text-xs uppercase tracking-widest">
                  <tr>
                    <th className="p-4 text-left">Item ID</th>
                    <th className="p-4 text-left">Name</th>
                    <th className="p-4 text-left">Assigned To</th>
                    <th className="p-4 text-left">Actions</th>
                  </tr>
                </thead>

                {/* BODY */}
                <tbody>
                  {items.map((item) => (
                    <tr
                      key={item.id}
                      className="border-b border-white/5 hover:bg-white/[0.05] transition-all"
                    >
                      <td className="p-4 font-medium text-blue-300">
                        {item.item_id}
                      </td>

                      <td className="p-4 text-white/70">
                        {item.item_name}
                      </td>

                      <td className="p-4 text-white/70">
                        {item.assigned_to_name || "—"}
                      </td>





                      <td className="p-4">
                        <div className="flex gap-2">

                          {/* EDIT */}
                          {/* <button
      onClick={() => setEditItem(item)}
      className="p-2 rounded-lg bg-blue-500/20 hover:bg-blue-500/30"
    >
      ✏️
    </button> */}

                          {/* DELETE */}
                          <button
                            onClick={() => setDeleteItem(item)}
                            className="p-2 rounded-lg bg-red-500/20 hover:bg-red-500/30"
                          >
                            🗑️
                          </button>

                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          )}
        </div>
      </div>

      {/* MODAL */}
      {/* <AssignItemModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          fetchItems(); // ✅ refresh after assign
        }}
      /> */}


      <AssignItemModal
        isOpen={isModalOpen || !!editItem}
        itemData={editItem} // null = add mode, object = edit mode
        onClose={() => {
          setIsModalOpen(false);
          setEditItem(null);
          fetchItems();
        }}
      />





      {deleteItem && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
          <div className="bg-white rounded-xl p-6 w-[320px] text-center">

            <h2 className="text-lg font-bold mb-3 text-red-600">
              Remove Assignment?
            </h2>

            <p className="text-gray-600 mb-4">
              Are you sure you want to unassign this item?
            </p>

            <div className="flex gap-3">
              <button
                onClick={() => setDeleteItem(null)}
                className="flex-1 bg-gray-300 py-2 rounded"
              >
                Cancel
              </button>

              <button
                onClick={handleDelete}
                disabled={deleteLoading}
                className="flex-1 bg-red-600 text-white py-2 rounded"
              >
                {deleteLoading ? "Removing..." : "Remove"}
              </button>
            </div>

          </div>
        </div>
      )}






      {responseModal.show && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
          <div className="bg-white p-6 rounded-xl w-[300px] text-center">

            <h2 className={`text-lg font-bold mb-3 ${responseModal.success ? "text-green-600" : "text-red-600"
              }`}>
              {responseModal.success ? "Success" : "Error"}
            </h2>

            <p className="text-gray-600 mb-4">
              {responseModal.message}
            </p>

            <button
              // onClick={() => setResponseModal({ ...responseModal, show: false })}
              onClick={() => {
                setResponseModal({ ...responseModal, show: false });
                setTimeout(() => {
                  window.location.reload();
                }, 300);
              }}
              className="bg-blue-600 text-white px-4 py-2 rounded"
            >
              OK
            </button>

          </div>
        </div>
      )}
    </>
  );
}

// import { useState } from "react";
// import { Plus, Package } from "lucide-react";
// import AssignItemModal from "./InventoryModals/AssignItemModal";

// export default function AssignItems() {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   return (
//     <>
//       <div
//         className="
//         rounded-2xl md:mt-20 p-5
//         bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//         text-white border border-white/10 shadow-2xl
//       "
//       >
//         {/* Header */}
//         <div className="flex justify-between items-center mb-4">
//           <h1 className="text-2xl font-bold">
//             Assign Inventory Items
//           </h1>

//           <button
//             onClick={() => setIsModalOpen(true)}
//             className="
//               flex items-center gap-2
//               bg-purple-600 hover:bg-purple-500
//               px-4 py-2 rounded-lg text-sm whitespace-nowrap
//             "
//           >
//             <Plus size={16} />
//             Assign Item
//           </button>
//         </div>

//         {/* Content area (same pattern as tables) */}
//         <div
//           className="
//           min-h-[300px]
//           border border-white/10 rounded-xl
//           bg-white/5
//           flex items-center justify-center
//         "
//         >
//           <div className="flex flex-col items-center">
//             <Package size={40} className="text-white/30 mb-3" />
//             <p className="text-white/60 text-sm">
//               No items assigned yet
//             </p>
//             <p className="text-white/40 text-xs mt-1">
//               Assigned inventory will appear here
//             </p>
//           </div>
//         </div>
//       </div>

//       <AssignItemModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//       />
//     </>
//   );
// }
